import button from "./button";
import cell from "./cell";
import cellItem from "./cell-item";
import checkbox from "./checkbox";
import header from "./header";
import icon from "./icon";
import loading from "./loading";
import popup from "./popup";
import scroll from "./scroll";
import dialog from "./dialog";
import toast from "./toast";
import Switch from "./switch";

export default {
    button,
    cell,
    cellItem,
    checkbox,
    header,
    icon,
    loading,
    popup,
    scroll,
    dialog,
    toast,
    switch: Switch
}
